import createWall from './wall'
import textureUrls from '../textures/urls'

/**
 * NOTE: This is old, just leaving for reference
 */
export default function createCastle({ pos, quat }) {
  /*createWall(10, pos, quat, {
    height: 4,
    textureUrl: textureUrls.stone,
    width: 8,
  })*/
  // Center Wall
  createWall(10, pos, quat, {
    height: 4,
    textureUrl: textureUrls.stone,
    width: 8,
  })
  createWall(12, pos, quat, {
    height: 4,
    textureUrl: textureUrls.stone,
    width: 8,
  })
  // Right Column
  createWall(8, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 4,
    z0os: 12,
  })
  createWall(10, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 1,
    z0os: 15,
  })
  createWall(12, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 1,
    z0os: 15,
  })
  createWall(14, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 4,
    z0os: 12,
  })
  createWall(10, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 1,
    z0os: 9,
  })
  createWall(12, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 1,
    z0os: 9,
  })

  // Left Column
  createWall(8, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 4,
    z0os: -12,
  })
  createWall(10, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 1,
    z0os: -15,
  })
  createWall(12, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 1,
    z0os: -15,
  })
  createWall(14, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 4,
    z0os: -12,
  })
  createWall(10, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 1,
    z0os: -9,
  })
  createWall(12, pos, quat, {
    height: 8,
    textureUrl: textureUrls.stone,
    width: 1,
    z0os: -9,
  })
}
